module.exports = __webpack_public_path__ + "media/images/lb/300-5d9ce5ce1714f5b27a7f32b671d7884f.svg";